"use strict";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SearchInput = void 0;

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _helpers = require("../../helpers");

var _useDebounce = require("../../hooks/useDebounce");

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) { return; } var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var InputWrapper = _styledComponents.default.div.withConfig({
  displayName: "InputWrapper",
  componentId: "sc-1a8hqcc-0"
})(["position:relative;svg:first-of-type{position:absolute;top:50%;left:0.75rem;transform:translate(0%,-50%);}svg:last-of-type{position:absolute;top:50%;right:0.75rem;transform:translate(0%,-50%);color:", ";}input{appearance:none;border:1.5px solid ", ";border-radius:6px;display:block;font-family:inherit;font-size:1rem;line-height:1.5rem;min-width:15rem;outline:none;padding:0.5rem;padding-left:2rem;width:100%;&:focus{border:1.5px solid ", ";outline:none;background:", ";}}"], (0, _helpers.color)('black60'), (0, _helpers.color)('black30'), (0, _helpers.color)('primary'), (0, _helpers.color)('white'));

var LabelWrapper = _styledComponents.default.div.withConfig({
  displayName: "LabelWrapper",
  componentId: "sc-1a8hqcc-1"
})(["margin-bottom:0.375rem;"]);

var BaseSearchInput = function BaseSearchInput(_ref) {
  var className = _ref.className,
      _ref$minChars = _ref.minChars,
      minChars = _ref$minChars === void 0 ? 3 : _ref$minChars,
      onChange = _ref.onChange,
      placeholder = _ref.placeholder,
      value = _ref.value,
      label = _ref.label,
      id = _ref.id;
  var searchInput = (0, _react.useRef)(null);

  var _useState = (0, _react.useState)(value || ''),
      _useState2 = _slicedToArray(_useState, 2),
      search = _useState2[0],
      setSearch = _useState2[1];

  var validSearch = search.length >= minChars || search.length === 0;
  var debouncedSearch = (0, _useDebounce.useDebounce)(validSearch ? search : '', 300);
  /* update search if value changes externally i.e. when clearing search value is set to '' */

  (0, _react.useEffect)(function () {
    if (validSearch && value !== search) setSearch(value);
  }, [value]);

  var handleChange = function handleChange(ev) {
    var _ev$target;

    setSearch((ev === null || ev === void 0 ? void 0 : (_ev$target = ev.target) === null || _ev$target === void 0 ? void 0 : _ev$target.value) || '');
  };

  (0, _react.useEffect)(function () {
    if (value !== debouncedSearch) onChange(debouncedSearch);
  }, [debouncedSearch]);
  return _react.default.createElement(_react.default.Fragment, null, label && _react.default.createElement(LabelWrapper, null, _react.default.createElement("label", {
    htmlFor: id
  }, label)), _react.default.createElement(InputWrapper, {
    className: className
  }, _react.default.createElement(_Icons.SearchIcon, null), search && _react.default.createElement(_Icons.CancelIcon, {
    onClick: function onClick() {
      setSearch('');
      searchInput.current.focus();
    }
  }), _react.default.createElement("input", {
    id: id,
    ref: searchInput,
    type: "text",
    value: search,
    onChange: handleChange,
    placeholder: placeholder
  })));
};

var SearchInput = (0, _styledComponents.default)(BaseSearchInput).withConfig({
  displayName: "SearchInput",
  componentId: "sc-1a8hqcc-2"
})([""]);
exports.SearchInput = SearchInput;